import React from "react";
import {inject, observer} from "mobx-react";

/**
 * Numéro de téléphone cliquable. Avec la téléphonie OVH configurée, un clic fait sonner le téléphone du magasin,
 * qui appelle ce numéro au décroché (click2call) ; sinon, lien tel: habituel. Le numéro est copié dans les deux cas.
 */
function PhoneRow({title, rootStore}) {

   function FrTel(tel){
        if(tel) {
            return tel.replace(/(\d\d(?!$))/g,"$1-");
        }
        return "";
    }

    function copy() {
        /* Copy the text original */
        navigator.clipboard.writeText(title);
    }

    const telephonie = rootStore?.telephonieStore;

    function onClick(e) {
        copy();
        if (title && telephonie?.click2call) {
            e.preventDefault();
            e.stopPropagation();
            telephonie.appeler(title);
        }
    }

    return <span className="mb-0 text-sm">
                            <a onClick={onClick}
                                onCopy={copy} href={"tel:" + title}
                                title={telephonie?.click2call ? "Appeler depuis le téléphone du magasin" : undefined}>
                              {telephonie?.click2call && title ? <i className="fa fa-phone mr-1" aria-hidden="true"/> : null}
                              { title ? FrTel(title) : ""}
                            </a>
                        </span>
}

export default inject("rootStore")(observer(PhoneRow));
